import Vue from 'vue';
import ObjectionReporting from './objection-reporting/objection-reporting.vue';
Vue.component('objection-reporting', ObjectionReporting);
